import * as TypeGraphQL from "type-graphql";
export var DeploymentEnvironment;
(function (DeploymentEnvironment) {
    DeploymentEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    DeploymentEnvironment["STAGING"] = "STAGING";
    DeploymentEnvironment["PRODUCTION"] = "PRODUCTION";
})(DeploymentEnvironment || (DeploymentEnvironment = {}));
TypeGraphQL.registerEnumType(DeploymentEnvironment, {
    name: "DeploymentEnvironment",
    description: undefined,
});
//# sourceMappingURL=DeploymentEnvironment.js.map